const UserRoleOptions = [
  { value: 1, label: "Admin" },
  { value: 2, label: "User" },
];

export default UserRoleOptions;
